import React, { useEffect } from 'react';
import { Form } from '@fiverr-private/forms';
import { Container } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { globalBigQueryReporter, globalGrafanaReporter } from '../../../events';
import { translate } from '../../../utils/translate';
import { FormSubmitButton } from '../common/FormSubmitButton';
import { useProfileSubmitHandler } from './hooks/useProfileSubmitHandler';
import { useProfileForm } from './hooks/useProfileForm';
import { FormInputField } from './FormInputField';

export const ProfileSetupStep = () => {
    const { loading, setLoading, methods, isUsernameAvailable, onUsernameChange } = useProfileForm();
    const { onSubmit } = useProfileSubmitHandler({ setError: methods.setError, setLoading });

    useEffect(() => {
        globalGrafanaReporter.count('identification.%{platform}.profile_setup.show');
        globalBigQueryReporter.send('identification.profile_setup.show');
    }, []);

    return (
        <Container display="flex" direction="column" flexGrow="1" gap="10">
            <Heading size={{ default: 'h_lg' }} fontWeight="bold">
                {translate('steps.profile_setup.title')}
            </Heading>

            <Form flexGrow="1" methods={methods} onSubmit={onSubmit}>
                <Container display="flex" direction="column" gap="6">
                    <Container display="flex" gap="4">
                        <FormInputField
                            flex="1"
                            name="firstName"
                            label={translate('steps.profile_setup.first_name')}
                            placeholder="John"
                            autoFocus
                        />
                        <FormInputField
                            flex="1"
                            name="lastName"
                            label={translate('steps.profile_setup.last_name')}
                            placeholder="Smith"
                        />
                    </Container>
                    <FormInputField
                        name="username"
                        label={translate('steps.profile_setup.choose_username')}
                        tooltip={translate('steps.profile_setup.tooltip_username')}
                        placeholder="John_smith"
                        isValidationFieldSuccess={isUsernameAvailable}
                        onChange={onUsernameChange}
                    />
                </Container>

                <Container marginTop="auto">
                    <FormSubmitButton loading={loading} label={translate('steps.profile_setup.create_account')} />
                </Container>
            </Form>
        </Container>
    );
};
